// @ts-nocheck
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBillTos } from "@insite/client-framework/Services/CustomersService";
import {
    chain,
    FindDefaultBillTo,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        page?: number; // Store Custom Code
        pageSize?: number; // Store Custom Code
    },
    {
        defaultBillTo?: BillToModel;
        defaultShipTo?: ShipToModel;
        showSelectDefaultCustomer: boolean;
        useDefaultCustomer: boolean;
        hasMultipleBillTos: boolean;
    }
>;

export const StoreFindDefaultBillTo: HandlerType = async props => {
    /* Store Custom Code */
    const params = {
        page: props.parameter.page,
        pageSize: props.parameter.pageSize,
    };
    /* Store Custom Code */
    const billToCollection = await getBillTos({ ...params }); // Store Custom Code - add params
    const billTos = billToCollection.billTos!;

    if (billTos.length === 1) {
        props.defaultBillTo = billTos[0];
    } else {
        const defaultBillTos = billTos.filter(o => o.isDefault);

        if (defaultBillTos.length === 1) {
            props.defaultBillTo = defaultBillTos[0];
        }
    }
};

replaceInChain(chain, FindDefaultBillTo, StoreFindDefaultBillTo);
